export enum RequestTypeEnum {
  RECEIVE = 'RECEIVE',
  SEND = 'SEND',
}
